import { render } from "./zhicheng-lesson.vue?vue&type=template&id=fb441762&scoped=true"
import script from "./zhicheng-lesson.vue?vue&type=script&lang=js"
export * from "./zhicheng-lesson.vue?vue&type=script&lang=js"

import "./zhicheng-lesson.vue?vue&type=style&index=0&id=fb441762&scoped=true&lang=less"

import exportComponent from "G:\\PRO\\fuvview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb441762"]])

export default __exports__